// Public booking transport is isolated from existing forms/CRM retry semantics.
const inflight = new Map();
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
export const isPublicBookingRequest = uri => /^\/api\/v1\/public\/(?:practices\/[^/?]+\/(?:info|treatments|practitioners|availability|available-dates|slots|reserve|release|booking-attempts|deposit-intent|booking-outcome|book|booking-pages)(?:\/|\?)|book\/[^/?]+\/(?:cancel|reschedule)\/|booking-embeds\/[^/?]+\/|virtual-consultations\/[^/?]+\/)/.test(uri || '');

export async function bookingApiRequest(config, options, execute) {
    const headers = { ...config.headers, Authorization: undefined };
    ['X-Booking-Session', 'Idempotency-Key'].forEach(name => {
        if (typeof options.headers?.[name] === 'string') headers[name] = options.headers[name];
    });
    const cfg = { timeout: 10000, ...config, headers, ...(options.signal ? { signal: options.signal } : {}) };
    const safe = ['GET', 'HEAD', 'OPTIONS'].includes(String(cfg.method).toUpperCase());
    const key = safe && !cfg.signal ? JSON.stringify([cfg.method, cfg.url, cfg.params, headers['X-Booking-Session'], headers['Idempotency-Key']]) : null;
    if (options.bustCache && key) inflight.delete(key);
    if (key && inflight.has(key)) return inflight.get(key);
    let attempt = 0;
    const run = async () => {
        try {
            const result = await execute(cfg);
            return { ok: true, status: result.status, data: result.data, headers: result.headers };
        } catch (error) {
            const response = error?.response;
            const status = response?.status || 0;
            const raw = response?.headers?.get?.('retry-after') ?? response?.headers?.['retry-after'];
            const number = /^\d+$/.test(String(raw ?? '').trim()) ? Number(raw) : NaN;
            const seconds = Number.isSafeInteger(number) ? number : null;
            const cancelled = cfg.signal?.aborted || error?.code === 'ERR_CANCELED';
            const retry = !cancelled && safe && attempt < 2 && (status === 429 ? seconds !== null && seconds <= 30 : !response || (status >= 500 && status !== 501));
            if (retry) {
                attempt += 1;
                await sleep(status === 429 ? seconds * 1000 : 250 * 2 ** attempt + Math.floor(Math.random() * 250));
                return run();
            }
            return { ok: false, status, data: response?.data ?? null, headers: response?.headers || {}, error, ...(status === 429 ? { retryAfter: { seconds } } : {}) };
        }
    };
    const call = run();
    if (key) inflight.set(key, call);
    try { return await call; }
    finally { if (key && inflight.get(key) === call) inflight.delete(key); }
}
